import { createSelector } from '@ngrx/store'

import { selectAuthState } from '../core.state'
import { AuthState } from './auth.models'

export const selectAuth = createSelector(
  selectAuthState,
  (state: AuthState) => state
)

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => state.isAuthenticated
)
export const selectExpirationDate = createSelector(
  selectAuthState,
  (state: AuthState) => state.expirationDate
)
export const selectCurrentUserId = createSelector(
  selectAuthState,
  (state: AuthState) => state.id
)

export const selectCurrentUserName = createSelector(
  selectAuthState,
  (state: AuthState) => state.name
)

export const selectCurrentUserProfile = createSelector(
  selectAuth,
  ({ name, username, email }) => ({ name, username, email })
)
